<template>
  <div>
    <div
      class="ec-answer ec-number ec-additional-results">
      <div class="ec-answer-main">
        <template v-for="(value, index) in response.data">
          <div 
            :key="index+'_a'" 
            class="ec-answer-text">
            <div class="input-additional-result-wrapper">
              <input 
                :disabled="$store.readOnly"
                v-model="value.label"
                class="input-additional-result"
                :placeholder="$t('additional_results_module.placeholder')">
              <button 
                :disabled="$store.readOnly"
                class="input-additional-result-addon is-blue"
                @click.prevent="removeValue(index)">
                <i 
                  class="fa fa-ban" 
                  aria-hidden="true" />
              </button>
            </div>
          </div>
          <div 
            :key="index+'_b'" 
            class="ec-answer-input">
            <div class="ec-answer-input-form">
              <input 
                :disabled="$store.readOnly"
                v-model="value.value"
                class="input-additional-result-value"
                type="number">
            </div>
            <div class="ec-answer-input-unit">EUR</div>
          </div>
        </template>
        <div style="text-align:right"><button
          :disabled="$store.readOnly"
          class="btn is-small is-blue add-additional-result" 
          href="#"
          @click.prevent="addValue">{{ $t('additional_results_module.add_entry') }}</button></div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
    
</style>
<script>
import { reject } from 'lodash'

export default {
    name: 'AdditionalResultsModule',
    props: {
        'module': {
            type: Object,
            required: true
        }
    },
    data: function() { return {
        response: { data: [{
            label: "",
            value: "0"
    }]},
        isRdyToSend: true
    }},
    watch: {
        response: {
            handler: function() {
                this.$event.$emit('calculation-changed')
            },
            deep:true
        }
    },
    mounted() {
        let initData = JSON.parse(this.module.value).data
        if(initData.length) {
            this.response.data = JSON.parse(this.module.value).data
        }
    },
    beforeDestroy() {
        Vue.delete(this.$store.rdyToSend, 'M' + this.module.type)
    },
    methods: {
        getResponseData() {
            let responseData = reject(this.response.data, function(item) {
                if(item.label) {
                    return false
                }

                return true
            })

            responseData = {data: responseData}

            return responseData
        },
        addValue() {
            this.response.data.push({
                label: "",
                value: "0"
            })
        },
        removeValue(index) {
            this.response.data.splice(index, 1)
        }
    },
}
</script>